<template>
  <div>
    <div v-if="packageEntities && packageEntities.length > 0">
      <!-- <div class="ui blue button"
           style="background-color: #092442"
           @click="showModal()"
           v-if="!cancelled">
        Add Package
      </div> -->
      <abstractTable :columns="packagesColumns" :data="computedPackages"
                     :classes="'ui very compact center aligned celled table'"
                     style="margin-top: 15px;">
      </abstractTable>
    </div>

    <div class="ui placeholder segment" v-else>
      <div class="ui icon header" style="color: #092442">
        <i class="dont icon"></i>
        No Packages Have Been Added Yet
      </div>
      <div class="ui primary button" style="background-color: #092442"
           @click="showModal()"
            v-if="!cancelled">
        Add Package
      </div>
    </div>

   <!--  <div class="ui large longer modal" id="transaction" style="margin-top: 20px !important;">
      <div class="header">{{ $t('addTransaction') }}</div>
      <div class="scrolling content">
        <div class="ui form">
          <div class="fields">
            <div class="field" style="width: 50%">
              <label for="transactionAmount">{{ $t('transactionAmount') }}</label>
              <div class="ui input left icon">
                <i class="money icon"></i>
                <input type="text" :placeholder="$t('transactionAmount')" v-model="transactionParams.amount">
              </div>
            </div>

            <div class="field" style="width: 50%">
              <label for="paidAt">{{ $t('paidAt') }}</label>
              <div style="text-align: center" class="ui calendar" id="reservation-transaction-paid-at">
                <div class="ui input left icon">
                  <i class="calendar icon"></i>
                  <input type="text" :placeholder="$t('paidAt')" readonly="" name="day">
                </div>
              </div>
            </div>
          </div>

          <div class="field">
            <label for="description">{{ $t('description') }}</label>
            <textarea :placeholder="$t('transactionAmount')" v-model="transactionParams.description">
            </textarea>
          </div>

          <div class="ui blue right floated button"
               style="background-color: #092442"
               @click="save()">
            {{ $t('save') }}
          </div>

          <div class="ui right floated button"
               @click="hideModal()">
            {{ $t('discard') }}
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    packageEntities: { type: Array, default: () => { return [] } },
    completePackages: { type: Array, default: () => { return [] } },
    reservationId: { type: Number, required: true },
    cancelled: { type: String, default: null },
    visits: { type: Array, default: () => [] }
  },
  data () {
    return {
      packageParams: {
        amount: null,
        description: null,
        paid_at: window.moment()
      }
    }
  },
  mounted () {
  },
  computed: {
    
    packagesColumns () {
      return [
        { header: 'Name', fieldName: 'name', show: true },
        { header: 'Description', fieldName: 'description', show: this.isAdmin() },
        { header: 'Unit Price', fieldName: 'unitPrice', show: this.isAdmin(), classes: 'positive' },
        { header: 'Quantity', fieldName: 'quantity', show: this.isAdmin() },
        { header: 'Package Price', fieldName: 'packagePrice', show: this.isAdmin(), classes: 'positive' },
        { header: 'Repeated', fieldName: 'repeated', show: this.isAdmin() },
        { 
          header: 'Total Price', 
          fieldName: 'totalPrice', 
          show: this.isAdmin() || this.$auth.check('employee'), 
          classes: 'positive' 
        },
        { header: 'Remainder Quantity', fieldName: 'remainder', show: true }
      ]
    },
    computedPackages () {
      let formlatePackages = []
      const notCancelledVisits = this.visits.filter (visit => visit.visit_status_id != this.VisitStatuses.CANCELLED)
      
      let visitDetails = window._.flattenDeep(notCancelledVisits.map(visit => visit.visit_details ))

      const groupedVisitDetails = visitDetails.reduce((objectsByKeyValue, obj) => {
          const value = obj['package_id'];
          objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
          return objectsByKeyValue;
        }, {})

      let getTotalUsage = packageId => {
        return window._.sumBy(groupedVisitDetails[packageId], visitDetail => {
          return visitDetail.quantity
        })
      }

      let getRemainder = (selectedPackage, repeated) => {
        let totalUsage = getTotalUsage(selectedPackage.id)
        let totalQuantity = selectedPackage.quantity * repeated
        return totalQuantity - totalUsage
      }

      let getPackage = packageId => {
        return this.completePackages.find(cPackage => {
          return cPackage.id === packageId
        })
      }
      window._.each(this.packageEntities, selectedPackageEntity => {
        let completePackage = getPackage(selectedPackageEntity.package_id)
        let packagePrice =
          Number(completePackage.unit_price) * Number(completePackage.quantity)

        let totalPrice = packagePrice * Number(selectedPackageEntity.repeated)
        formlatePackages.push({
          name: completePackage.name,
          description: completePackage.description,
          unitPrice: this.formatPrice(completePackage.unit_price),
          quantity: completePackage.quantity,
          packagePrice: this.formatPrice(packagePrice),
          repeated: selectedPackageEntity.repeated,
          totalPrice: this.formatPrice(totalPrice),
          remainder: getRemainder(completePackage, selectedPackageEntity.repeated)
        })
      })

      return formlatePackages
    }
  },
  methods: {
    showModal () {
      $('#transaction').modal('show').modal('refresh')
      this.initGui()
    },
    hideModal () {
      this.transactionParams = {
        amount: null,
        description: null,
        paid_at: window.moment()
      }

      $('#transaction').modal('hide')
    },
    initGui () {
      this.$nextTick(() => {
        $('#reservation-transaction-paid-at').calendar({
          type: 'datetime',
          onChange: (date) => {
            this.transactionParams.paid_at = date
          },
          isDisabled: (date, mode) => {
            return false
          }
        })
      })
    },
    save () {
      // TODO: Send save request
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/reservations/reservation_components/PackagesPart.vue